import { CallRow } from "../../api/call/call.types";
import { toTitleCase } from "../../lib/string";
import { formatDate } from "../../components/utls/time";

function formatDuration(seconds: number | null) {
  if (seconds === null || seconds === undefined) {
    return "Duration unavailable";
  }

  if (seconds < 60) {
    return `${seconds}s`;
  }

  const minutes = Math.floor(seconds / 60);
  const remaining = seconds % 60;
  return `${minutes}m ${remaining}s`;
}

function buildCallLabel(item: CallRow) {
  const parts = [item.direction, item.status]
    .filter((value): value is string => Boolean(value))
    .map((value) => toTitleCase(value));

  return parts.length > 0 ? parts.join(" • ") : "Call";
}

export function CallListItem({
  item,
  isSelected = false,
  onSelect,
}: {
  item: CallRow;
  isSelected?: boolean;
  onSelect?: (id: string) => void;
}) {
  const title = buildCallLabel(item);
  const fromLabel = item.from_number ?? "Unknown origin";
  const toLabel = item.to_number ?? "Unknown destination";
  const startedAt = item.started_at ?? item.created_at;
  const startedLabel = startedAt ? formatDate(startedAt) : "Unknown start";

  return (
    <li>
      <button
        type="button"
        onClick={() => onSelect?.(item.id)}
        className={[
          "flex w-full flex-col gap-1 rounded-lg px-3 py-4 text-left",
          "transition-colors hover:bg-cream-100",
          isSelected ? "bg-cream-100" : "",
        ].join(" ")}
      >
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="text-sm font-semibold text-brown-900">{title}</div>
          <div className="text-xs text-brown-500">{item.id}</div>
        </div>
        <div className="text-sm text-brown-700">
          From {fromLabel} to {toLabel}
        </div>
        <div className="text-xs text-brown-500">
          Started {startedLabel} • {formatDuration(item.duration_seconds)}
        </div>
      </button>
    </li>
  );
}
